export const getEndOfToday = (minDate?: Date) => {
  const now = new Date();
  const endOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);

  // If minDate is provided and endOfToday is before minDate, return minDate instead
  if (minDate && endOfToday < minDate) {
    return minDate;
  }

  return endOfToday;
};
